import { I18N } from '@/app'
import { testerOptions } from '@/app/testers'
import { createForm, yup } from '@codeleap/common'

import { initialState } from './shared'

export const loginForm = () =>
  createForm('login', {
    email: {
      type: 'text',
      placeholder: 'email@email.com',
      validate: yup.string().required().email(),
      'aria-label': I18N.t('form.label.email'),
      'aria-required': true,
      defaultValue: initialState?.email,
      label: I18N.t('form.label.email')
    },
    password: {
      type: 'text',
      password: true,
      'aria-label': I18N.t('form.label.name'),
      'aria-required': true,
      placeholder: I18N.t('form.placeholder.password'),
      label: I18N.t('form.label.password'),
      defaultValue: initialState?.password,
      description: I18N.t('form.description.password'),
      validate: yup.string().required()
    },
    remember: {
      type: 'checkbox',
      label: I18N.t('form.label.remember'),
      defaultValue: true
    },
    tester: {
      type: 'select',
      label: 'Tester',
      options: testerOptions,
      defaultValue: 'default'
    }
  })
